module.exports = __webpack_public_path__ + "media/images/gallery/constellations/aquila/aql_oc-4b84a13f12f91fd77655f119a21ee722.gif";